// extracted by mini-css-extract-plugin
export default {"link":"VM-z","disabled":"WM-z"};